import type {
  AgentStoryDetailsValues,
  DataStoryStepBodyProps,
  DataStoryStepSeed,
} from "../../../services/dataStories/dataStoryFlow.types";

export type AgentStoryDetailsStepProps =
  DataStoryStepBodyProps<AgentStoryDetailsValues>;

/**
 * Empty form — the registry's `initialValues` for this step. A factory rather
 * than a shared constant so two steps can never alias the same
 * `selectedSourceIds` array.
 *
 * The seed carries which agent card was clicked; the frame's header renders it,
 * so it is the one field that is not blank on arrival. Opens on the connectors
 * tab with nothing selected, matching Figma 5326:88960 — an empty selection
 * means "don't narrow the sources", not "no sources".
 */
export const emptyAgentStoryDetails = (
  seed: DataStoryStepSeed,
): AgentStoryDetailsValues => ({
  recipeId: seed.recipeId,
  goal: "",
  sourceKind: "connectors",
  selectedSourceIds: [],
  selectedModelId: "",
  isAddingSource: false,
  isModelOpen: false,
});
